import { render } from "./IconMaskedLock.vue?vue&type=template&id=c8406500"
import script from "./IconMaskedLock.vue?vue&type=script&lang=ts"
export * from "./IconMaskedLock.vue?vue&type=script&lang=ts"
script.render = render

export default script